export const ARTICLE_BODY_HEADING_CLASS = "article-body-heading";

export const demoteArticleBodyH1Tags = (html = "") => String(html)
  .replace(/<h1\b([^>]*)>/gi, (_match, attributes = "") => {
    const nextAttributes = /\sclass\s*=/.test(attributes)
      ? attributes.replace(/\sclass\s*=\s*(["'])(.*?)\1/i, (_classMatch, quote, className) => (
        ` class=${quote}${className} ${ARTICLE_BODY_HEADING_CLASS}${quote}`
      ))
      : `${attributes} class="${ARTICLE_BODY_HEADING_CLASS}"`;

    return `<h2${nextAttributes}>`;
  })
  .replace(/<\/h1>/gi, "</h2>");
